module.exports = __webpack_public_path__ + "static/img/unchecked.72fb45ad.svg";